// extracted by mini-css-extract-plugin
export default {"supplier":"Suppliers_supplier__En14G","wrapper":"Suppliers_wrapper__UB0yj","supplier-box":"Suppliers_supplier-box__iSLZ7"};